import NavBarButton from "../../../buttons/NavBarButton";

export const HM_NavBar = ({ tab, setTab }) => {
  return (
    <div className="flex flex-col w-c200 ">
      <NavBarButton
        onClick={() => setTab("kpis")}
        isActualPage={tab === "kpis"}
        icon={"email"}
        parameter={true}
      >
        KPIs
      </NavBarButton>
      <NavBarButton
        onClick={() => setTab("history")}
        isActualPage={tab === "history"}
        icon={"email"}
        parameter={true}
      >
        Historique
      </NavBarButton>
      <NavBarButton
        onClick={() => setTab("campaigns")}
        isActualPage={tab === "campaigns"}
        icon={"email"}
        parameter={true}
      >
        Campagnes
      </NavBarButton>
      <NavBarButton
        onClick={() => setTab("emails")}
        isActualPage={tab === "emails"}
        icon={"email"}
        parameter={true}
      >
        Emails
      </NavBarButton>
      <NavBarButton
        onClick={() => setTab("bulks")}
        isActualPage={tab === "bulks"}
        icon={"email"}
        parameter={true}
      >
        Bulks
      </NavBarButton>
    </div>
  );
};
